/* City normalization for the talent board filter.
   Profile cities are free text — production data holds "New York" as 14+
   spellings ("NYC", "new york", "Brooklyn", "New York CIty, NY"…). We condense
   aliases/casing/typos for display + filtering WITHOUT touching stored data. */

const ALIASES = {
  // New York — city, abbreviations, typos, boroughs
  "new york": "New York", "nyc": "New York", "new york city": "New York", "ny": "New York",
  "newyork": "New York", "new yorj": "New York", "new york ny": "New York",
  "new york new york": "New York", "new york city ny": "New York",
  "brooklyn": "New York", "brooklyn ny": "New York", "brooklyn new york": "New York",
  "bronx": "New York", "queens": "New York", "long island city": "New York",
  // Los Angeles
  "los angeles": "Los Angeles", "la": "Los Angeles", "los ageles": "Los Angeles",
  "los angeles california": "Los Angeles",
  // Fashion capitals with language variants
  "paris": "Paris", "paris france": "Paris",
  "london": "London", "london uk": "London", "londres": "London",
  "rome": "Rome", "roma": "Rome",
  "milan": "Milan", "milano": "Milan",
  // Variants seen in live data
  "miami": "Miami", "miami fl": "Miami", "miami florida": "Miami", "miami beach": "Miami",
  "atlanta": "Atlanta", "atlanta ga": "Atlanta", "atlanta georgia": "Atlanta",
  "saint paul": "Saint Paul", "st paul": "Saint Paul",
  "washington": "Washington, DC", "washington dc": "Washington, DC",
  "lagos": "Lagos", "lagos nigeria": "Lagos",
  "istanbul": "Istanbul",
  "bogota": "Bogotá",
  "san francisco": "San Francisco", "san francsico": "San Francisco",
  "boston": "Boston", "boston ma": "Boston",
  "tampa": "Tampa", "tampa fl": "Tampa", "tampa florida": "Tampa",
  "orlando": "Orlando", "orlando fl": "Orlando",
  "kuala lumpur": "Kuala Lumpur", "kuala lumpur malaysia": "Kuala Lumpur",
  "lisbon": "Lisbon",
};

const SEPARATORS = /[\/+]|\s+&\s+/; // "Paris/Marseille", "Toronto / NYC", "A + B"

function cleanup(part) {
  return part
    .split(",")[0]                          // "Miami, FL" → "Miami" (comma tails are state/country context)
    .replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, "") // emoji + flag glyphs
    .replace(/\s+[A-Z]{2}$/, "")            // trailing US state code: "Chapel Hill NC" → "Chapel Hill"
    .replace(/\s+/g, " ")
    .replace(/[.,\s]+$/g, "")
    .trim();
}

function titleCase(s) {
  return s.toLowerCase().replace(/(^|[\s'–-])(\p{L})/gu, (m, sep, ch) => sep + ch.toUpperCase());
}

export function normalizeCity(part) {
  const c = cleanup(part || "");
  if (!c) return "";
  const key = c.toLowerCase().normalize("NFKD").replace(/\p{M}/gu, "").replace(/\./g, ""); // accent+period-insensitive lookup
  if (ALIASES[key]) return ALIASES[key];
  if (c.length <= 3 && c === c.toUpperCase() && /^\p{Lu}+$/u.test(c)) {
    return c.length === 2 ? "" : c; // "GA"/"FL" are junk tails; "UAE" is a real answer
  }
  return titleCase(c);
}

/* Every distinct city a profile belongs to: "Paris/Marseille" lists under both. */
export function profileCities(raw) {
  if (!raw) return [];
  const out = [];
  for (const p of String(raw).split(SEPARATORS)) {
    const n = normalizeCity(p);
    if (n && !out.includes(n)) out.push(n);
  }
  return out;
}

/* Primary city for card display. */
export function displayCity(raw) {
  return profileCities(raw)[0] || (raw || "").trim();
}

/* Sorted, deduped filter options from a roster. */
export function cityFilterOptions(models) {
  const set = new Set();
  models.forEach((m) => profileCities(m.city).forEach((c) => set.add(c)));
  return [...set].sort((a, b) => a.localeCompare(b));
}
